export const DEBOUNCE_LOW = 500;
export const DEBOUNCE_MID = 1000;
export const TOOLTIP_DEBOUNCE = 5000;
